<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="width: 90%;margin-left: 5%;padding-top: 1rem">
        <div class="title">招聘公告</div>
        <div style="display: flex">
          <div class="name">RECRUITMENT ANNOUNCEMENT</div>
          <div style="width: 50%">
            <el-divider></el-divider>
          </div>
        </div>
      </div>
        <div style="min-height: 25rem">
          <div :class="['news',item.isHovered ? 'hover-shadow':'']" @click="toDetails(item)" v-for="item in dataList" :key="item.id" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
            <div :style="{
              fontSize :item.isHovered ? '21px':'',
              color:item.isHovered ? '#1196db':''}" class="news_title" v-bind:title="item.title">{{item.title}}</div>
            <div :style="{
              color:item.isHovered ? '#1196db':''}" class="news_date">{{item.publishDate.substring(0,10)}}</div>
          </div>
        </div>
      <div style="width: 100%;text-align: center">
        <el-pagination
            background
            style="text-align: center"
            layout="prev, pager, next"
            :total="total"
            :current-page="queryArticle.pageNum"
            :page-size="queryArticle.pageSize"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {getArticleList} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'index',
  data() {
    return {
      loading:false,
      date:undefined,
      dataList:[],
      total:undefined,
      queryArticle: {
        category:8,
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.initDataList()
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods:{
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    handleCurrentChange(pageNum){
      this.queryArticle.pageNum=pageNum
      this.initDataList()
    },
    toDetails(item){
      item.isHovered=false
      this.$router.push({path:"/recruit/details",query:{id:item.id}})
    },
    initDataList(){
      getArticleList(this.queryArticle).then(res=>{
        const data =res.data.content
        for (let i = 0; i <data.length ; i++) {
          data[i].isHovered=false
        }
        this.total=res.data.totalElements
        this.dataList=data

      })
    }
  }
}
</script>

<style scoped>
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.news_date{
  text-align: center;
  width: 20%;
  cursor: pointer;
}
.news_title{
  text-align: left;
  cursor: pointer;
  width: 80%;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news{
  display: flex;
  width: 90%;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 100;
  height: 60px;
  border-bottom: 1px solid  #bfbfbf;
  margin-left: 5%;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 50%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.home{
  padding-top: 4rem;
  width: 100%;
  background-color: #efefef;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
</style>
